import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { HttpService } from "../http.service";
import { QueryParams } from "services/models/odata/queryParams";
import { ServiceBase } from "../servicebase";
import { Observable } from "rxjs";
import { Response } from "services/models/response";
import { map } from "rxjs/operators";
import { MovementTypeModel } from "services/models/movementType.model";
@Injectable({
  providedIn: 'root'
})
export class WorkforceplanMovementTypeService extends ServiceBase<MovementTypeModel> {

  constructor(http: HttpService) {
    super("jobtitle", http, environment.apiUrl);
  }

  createEntity(input: any): MovementTypeModel {
    return MovementTypeModel.create(input);
  }

  listMovementTypes(): Observable<Response<MovementTypeModel[]>> {
    const params = {
      select: ["id", "name", "foreignId"],
      orderBy: "foreignId",
      orderByOrder: "asc",
    } as QueryParams;

    const query = this.createBuildQuery(params);
    return this.http
      .get(

        `${this.endpoint}/change-type/odata${query}`,
        undefined,
        this.baseUrl,
        null,
        true
      )
      .pipe(
        map((res) => {
          const response = new Response<MovementTypeModel[]>();
          response.data = res.body.map(
            (pp) => this.createEntity(pp) as MovementTypeModel
          );
          response.count = res.headers.get("x-count");
          return response;
        })
      );
  }
}
